import { useTranslation } from 'react-i18next'

import {
  ErrorType,
  MessagesModel,
  MetaModel,
  MetaStatusCodes,
  NotificationSeverity,
  contentErrors,
} from '@/Shared/domain'
import { useNotification } from '@/Shared/ui/notifications'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export interface NotificationHandler {
  notificationHandler: (meta: MetaModel, successNotification?: boolean) => void
}

export const useNotificationHandler = (): NotificationHandler => {
  const { t } = useTranslation()
  const { addNotification } = useNotification()

  const notificationHandler = (meta: MetaModel, successNotification?: boolean): void => {
    if (
      meta?.status === MetaStatusCodes.SUCCESS ||
      meta?.status === MetaStatusCodes.INFO
    ) {
      successNotification &&
        addNotification(t(formTranslation.success.message), NotificationSeverity.success)
    }

    handleError(meta)
  }

  const handleError = (meta: MetaModel): void => {
    if (meta?.status === MetaStatusCodes.ERROR) {
      const contentError = meta.messages.filter((msg: MessagesModel) =>
        contentErrors.some((error: ErrorType) => msg.code === error.type),
      )

      if (contentError.length > 0) {
        const msgs = contentError.map((msg: MessagesModel) => msg.description).join(' ')

        addNotification(msgs, NotificationSeverity.error)
      } else {
        addNotification(meta.messages[0].description, NotificationSeverity.error)
      }
    }

    if (!meta || meta === undefined || meta === null) {
      addNotification(t(formTranslation.errors.genericError), NotificationSeverity.error)
    }
  }

  return { notificationHandler }
}
